import { createContext, useContext } from "react";
import { ButtonGroupProps } from "./ButtonGroup";

interface ButtonGroupContextType {
  fullWidth?: ButtonGroupProps["fullWidth"];
  variant?: ButtonGroupProps["variant"];
  color?: ButtonGroupProps["color"];
  size?: ButtonGroupProps["size"];
  orientation?: ButtonGroupProps["orientation"];
  isRenderInGroup?: boolean;
}

const ButtonGroupContext = createContext<ButtonGroupContextType | undefined>(
  undefined
);

export const useButtonGroupContext = () => {
  const context = useContext(ButtonGroupContext);
  if (!context) {
    return {};
  }
  return context;
};

interface ButtonGroupProviderProps extends ButtonGroupContextType {
  children: React.ReactNode;
}

export const ButtonGroupProvider: React.FC<ButtonGroupProviderProps> = ({
  children,
  variant,
  orientation,
  color,
  size,
  fullWidth,
}) => {
  return (
    <ButtonGroupContext.Provider
      value={{ variant, color, size, fullWidth, orientation }}
    >
      {children}
    </ButtonGroupContext.Provider>
  );
};
